import {useDispatch, useSelector} from "react-redux";
import {FIELD_LIST_SEO_GENERAL} from "../../utils/input-field-list-static-page";
import {setMainPageErrorMessage, setMainPageSeoDetail} from "../../reducers/main-page.reducer";
import React, {useEffect} from "react";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";
import FormGeneralComponent from "../../components/static-page/form-general.component";

const Seo = () => {
    const dispatch = useDispatch()
    const {seoDetail, mainPageErrorMessage} = useSelector(state => state.mainPageReducer)
    const {fetching: getSEO} = useFetch(API.HOMEPAGE_GET_SEO)
    const {fetching: updateSEO, isLoading} = useFetch(API.HOMEPAGE_UPDATE_SEO)
    let fieldListGeneral = FIELD_LIST_SEO_GENERAL
    let showSeo = {
        label: 'SEO',
        key: 'show_seo',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setMainPageSeoDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateSEO(seoDetail).then(response => {
            dispatch(setMainPageErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('SEO Updated'))
            dispatch(setMainPageSeoDetail(response?.data))
        }).catch(err => {
            dispatch(setMainPageErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getSEO().then(response => {
            dispatch(setMainPageSeoDetail(response?.data))
        })

        return () => {
            dispatch(setMainPageErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            title={'General'}
            data={seoDetail}
            switchToggleField={showSeo}
            fieldList={fieldListGeneral}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'col space-y-4 w-1/2'}
            errorMessage={mainPageErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default Seo